module.exports = __webpack_public_path__ + "img/wealthbottom2.aa6db62b.png";